import React, { useEffect, useCallback, useState, useRef } from 'react';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { Alert, AlertIcon } from '@chakra-ui/react';

import api from '../../../services/api';
import getValidationErrors from '../../../utils/getValidationErrors';
import Input from '../../Inputs/Input';
import InputSelect from '../../Inputs/Selects/InputSelect';
import InputDate from '../../Inputs/InputDate';

import { Container, Content, Header, FormView, ButtonsView } from './styles';

const tiposValor = [
  { id: 'V', label: 'Valor' },
  { id: 'P', label: 'Percentual' },
];

interface ModalPARAMS {
  id?: string;
  onClose: any;
  isVisible: boolean;
  setCupons: any;
  cupom: CupomDATA;
}
interface CupomDATA {
  cat: number;
  cod_cupom: string;
  cod_desc: string;
  cupom: string;
  dat_cadastro: string;
  formapg: string;
  id_cliente: string;
  id_desconto: string;
  nome: string;
  orig: string;
  prim: string;
  primeira_comp: string;
  selec_est: string;
  tip: string;
  val: number;
  val_min: number;
  validade: string;
  valor: string;
  vencimento: string;
  vlr_minimo: string;
}

const ModalCupom: React.FC<ModalPARAMS> = ({
  onClose = () => {},
  isVisible,
  setCupons,
  cupom = {} as CupomDATA,
}) => {
  const handleOnClose = useCallback(() => {
    formRef.current?.reset();
    setVisible(false);
    setTimeout(() => {
      onClose();
    }, 300);
  }, [onClose]);

  const formRef = useRef<FormHandles>(null);
  const [visible, setVisible] = useState(isVisible);
  const [radioPriComp, setRadioPriComp] = useState(
    cupom.prim ? cupom.prim : 'N',
  );
  const [messageVisible, setMessageVisible] = useState(false);
  const [message, setMessage] = useState('');

  const handleMoeda = useCallback((id_field: string) => {
    let moedastr = formRef.current?.getFieldValue(`${id_field}`);
    moedastr = moedastr.replace(/\D/g, '');

    if (moedastr) {
      const moeda = parseInt(moedastr.replace(/[\D]+/g, ''));

      let tmp = `${moeda}`;
      tmp = tmp.replace(/([0-9]{2})$/g, ',$1');
      if (tmp.length > 6)
        tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, '.$1,$2');

      formRef.current?.setFieldValue(`${id_field}`, `R$ ${tmp}`);
    } else {
      moedastr = moedastr.replace(/\D/g, '');
      formRef.current?.setFieldValue(`${id_field}`, `${moedastr}`);
    }
  }, []);

  const handlePercentualBlur = useCallback(() => {
    let moedastr = formRef.current?.getFieldValue('val');
    moedastr = moedastr.replace(/( )+/g, '');
    moedastr = moedastr.replace(/\D/g, '');

    if (moedastr) {
      moedastr = moedastr.replace('R$ ', '').replace('%', '');

      formRef.current?.setFieldValue('val', `${moedastr}%`);
    }
  }, []);
  const handlePercentualChange = useCallback(() => {
    let moedastr = formRef.current?.getFieldValue('val');
    moedastr = moedastr.replace(/( )+/g, '');
    moedastr = moedastr.replace(/\D/g, '');

    if (moedastr) {
      formRef.current?.setFieldValue('val', `${moedastr}`);
    } else {
      moedastr = moedastr.replace(/\D/g, '');
      formRef.current?.setFieldValue('val', `${moedastr}`);
    }
  }, []);

  const handleSubmit = useCallback(
    async (data: any) => {
      try {
        formRef.current?.setErrors({});

        data.prim = radioPriComp;

        const schema = Yup.object().shape({
          id_cliente: Yup.string(),
          cod_cupom: Yup.string(),
          vencimento: Yup.string().required('Campo obrigatório.'),
          tip: Yup.string().required('Campo obrigatório.'),
          val: Yup.string().required('Campo obrigatório.'),
          val_min: Yup.string(),
          prim: Yup.string(),
        });
        await schema.validate(data, {
          abortEarly: false,
        });

        let auxValor = data.val
          .replace('R$ ', '')
          .replace(',', '.')
          .replace('%', '');
        let auxVlr_min = data.val_min.replace('R$ ', '').replace(',', '.');

        auxValor = parseFloat(auxValor);
        auxVlr_min = data.val_min ? parseFloat(auxVlr_min) : 0;

        await api
          .post('portal/cupom/store', {
            id_cliente: data.id_cliente,
            id_cupom: cupom.id_desconto || 0,
            cod_cupom: data.cod_cupom,
            vencimento: data.vencimento,
            orig: 'M',
            cat: 1,
            val: auxValor,
            tip: data.tip,
            val_min: auxVlr_min,
            prim: data.prim,
            formapg: 'N',
            selec_est: 'S',
          })
          .then(response => {
            if (response.data.check.che === 'N') {
              setMessage(response.data.check.men);
              setMessageVisible(true);
              return;
            }

            formRef.current?.reset();
            setCupons(response.data.cupons);
            handleOnClose();
          });
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
        }
      }
    },
    [radioPriComp, setCupons, handleOnClose, cupom],
  );

  const handlePrimeiraCompra = useCallback(() => {
    if (radioPriComp === 'N') {
      setRadioPriComp('S');
    } else {
      setRadioPriComp('N');
    }
  }, [radioPriComp]);

  useEffect(() => {
    if (cupom.id_desconto) {
      formRef.current?.setFieldValue('id_cliente', cupom.id_cliente);
      formRef.current?.setFieldValue('cod_cupom', cupom.cod_cupom);
      formRef.current?.setFieldValue('vencimento', cupom.vencimento);
      formRef.current?.setFieldValue('tip', cupom.tip);
      formRef.current?.setFieldValue('val', cupom.val);
      formRef.current?.setFieldValue('val_min', cupom.val_min);

      if (cupom.tip === 'P') {
        handlePercentualBlur();
      } else {
        formRef.current?.setFieldValue('val', cupom.valor);
        handleMoeda('val');
      }

      handleMoeda('val_min');
    }
  }, [cupom, handleMoeda, handlePercentualBlur]);

  return (
    <Container id="modalCupom">
      <Content className={`${visible ? 'active' : ''}`}>
        <Header>
          <h1>Cadastro de Cupom</h1>
          <h2>Aqui você cadastra um novo cupom de desconto.</h2>
        </Header>

        <FormView ref={formRef} onSubmit={handleSubmit}>
          {messageVisible && (
            <Alert
              status="error"
              style={{
                marginTop: '10px',
                marginBottom: '10px',
                borderRadius: '10px',
              }}
            >
              <AlertIcon />
              {message}
            </Alert>
          )}

          <div className="input">
            <p>
              Cliente <span>(opcional)</span>
            </p>
            <Input
              name="id_client"
              type="text"
              placeholder="email, telefone ou cpf do cliente"
              containerStyle={{ padding: '5px 10px' }}
            />
          </div>

          <div className="inputs">
            <div className="input">
              <p>
                Código do cupom <span>(opcional)</span>
              </p>
              <Input
                name="cod_cupom"
                type="text"
                placeholder="Código do cupom"
                containerStyle={{ padding: '5px 10px' }}
              />
            </div>

            <div className="input">
              <p>
                Vencimento do cupom <span>(obrigatório)</span>
              </p>
              <InputDate
                name="vencimento"
                containerStyle={{ padding: '5px 10px' }}
              />
            </div>
          </div>

          <div className="inputs">
            <div className="input">
              <p>
                Tipo de valor <span>(obrigatório)</span>
              </p>
              <InputSelect
                name="tip"
                options={tiposValor}
                placeholder="Tipo de valor"
                defaultValue=""
                containerStyle={{ padding: '5px 10px' }}
                onChange={() => formRef.current?.clearField('val')}
              />
            </div>

            <div className="input">
              <p>
                Valor do cupom <span>(obrigatório)</span>
              </p>
              <Input
                name="val"
                type="text"
                placeholder="Valor do cupom"
                onChange={() => {
                  formRef.current?.getFieldValue('tip') === 'V'
                    ? handleMoeda('val')
                    : handlePercentualChange();
                }}
                onBlur={() => {
                  formRef.current?.getFieldValue('tip') === 'P' &&
                    handlePercentualBlur();
                }}
                containerStyle={{ padding: '5px 10px' }}
              />
            </div>
          </div>

          <div className="inputs">
            <div className="input">
              <p>
                Valor mínimo da compra <span>(opcional)</span>
              </p>
              <Input
                name="val_min"
                type="text"
                placeholder="Valor mínimo"
                containerStyle={{ padding: '5px 10px' }}
                onChange={() => handleMoeda('val_min')}
              />
            </div>

            <div className="radio-group">
              <div className="radio">
                <div className="radio-label">
                  <input
                    name="pri"
                    type="radio"
                    checked={radioPriComp === 'S'}
                    onClick={handlePrimeiraCompra}
                    onChange={() => {}}
                  />
                  <label>Primeira Compra</label>
                </div>
              </div>
            </div>
          </div>

          <ButtonsView>
            <button
              className="btn-cancel"
              type="button"
              onClick={handleOnClose}
            >
              Cancelar
            </button>
            <button className="btn-save" type="submit">
              Salvar
            </button>
          </ButtonsView>
        </FormView>
      </Content>
    </Container>
  );
};

export default ModalCupom;
